<template>
  <div>
    <main-header-plat-a />
    <v-tab-vertical :legalItems="schema.legalItems" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import VTabVertical from '@/components/base/VTabVertical.vue';

export default {
  name: 'ProLegalPage',
  components: {
    MainHeaderPlatA,
    VTabVertical,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('proLegalPage', ['schema']),
  },
  methods: {
    ...mapActions('proLegalPage', ['loadSchema']),
  },
};
</script>
